import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "app/app-routing.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { StoreModule } from "@ngrx/store";
import { reducers } from "app/reducers";
import { HttpClientModule } from "@angular/common/http";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "environments/environment";
import { NgxMaskDirective } from "ngx-mask";
import { SharedModule } from "app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { CoreModule } from "app/core/core.module";
import { SmartAppBannerModule } from "app/shared/modules/smart-app-banner/smart-app-banner.module";
import { AnalyticsModule } from "app/shared/modules/analytics/analytics.module";
import { GoogleAnalyticsModule } from "app/shared/modules/google-analytics/google-analytics.module";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

export const appModuleImports = [
  AppRoutingModule,
  BrowserModule,
  BrowserAnimationsModule,
  TranslateModule.forRoot({
    loader: provideTranslateHttpLoader({
      prefix: "./assets/i18n/",
      suffix: ".json"
    })
  }),
  StoreModule.forRoot(reducers, {
    runtimeChecks: {
      strictStateImmutability: false,
      strictActionImmutability: false
    }
  }),
  HttpClientModule,
  ServiceWorkerModule.register("/ngsw-worker.js", { enabled: environment.production }),
  NgxMaskDirective,
  CoreModule,
  SharedModule,
  SmartAppBannerModule,
  AnalyticsModule,
  GoogleAnalyticsModule
];
